import { useTranslation } from 'react-i18next';
import { useDiscardNotices, dismissDiscardNotice } from '../../services/discardNotices';
import './DiscardedPhotoNotice.css';

// Toast fijo inferior para los avisos de la maquinaria offline (foto
// descartada tras el ciclo controlado, detalle borrado en el portal,
// pendientes envejecidos). Requisitos que cumple a la vez:
//  - NO bloqueante (nunca un alert(): congelaría la pasada de sync).
//  - position:fixed, fuera del flujo — aparecer/desaparecer no desplaza la
//    lista bajo el dedo.
//  - Persiste hasta que el usuario lo cierra: los eventos son raros y no
//    deben pasar desapercibidos.
export function DiscardedPhotoNotice() {
  const { t } = useTranslation();
  const notices = useDiscardNotices();
  if (notices.length === 0) return null;
  return (
    <div className="discard-notices" role="alert">
      {notices.map((n) => (
        <div className="discard-notice" key={n.id}>
          <span className="discard-notice__msg">{t(n.i18nKey, n.params)}</span>
          <button
            type="button"
            className="discard-notice__close"
            onClick={() => dismissDiscardNotice(n.id)}
            aria-label={t('common.close')}
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
